module.exports = __webpack_public_path__ + "img/ennetix-users-profile-page.379f610c.png";